<div class="img-magnifier-container position-relative mb-4">
  <img *ngIf="!image" id="image{{ randomId }}" [src]="actualImage" [alt]="alt" />
  <image-srcset
    [width]="width"
    [height]="height"
    *ngIf="image"
    imgId="image{{ randomId }}"
    [alt]="alt"
    [item]="image"
  ></image-srcset>
</div>
